import { observable } from 'mobx';
import { diContainer, serviceNames } from '../../../service-setup/diContainer';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface ICategory {
    id: string;
    value: string;
    url?: string;
}

export class Category {
    @observable public id: string = '';
    @observable public value: string = '';
    @observable public url: string = '';

    constructor(id: string) {
        const urlFormatter = diContainer.get(serviceNames.urlFormatter);
        this.id = id ? id : this.id;
        const url = id ? `/products/${id}` : this.url;
        this.url = urlFormatter.langPrefixUrl(url);
    }

    public static fromJson(data: ICategory): Category {
        if (!data) {
            return new Category('');
        }
        const category = new Category(data.id);
        copyPropertiesExcludeNullsAndGetters(category, data);

        return category;
    }
}
